var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { enableDisableCaregiverService, getCaregiverService } from "services/CaregiverAccountService/caregiverAccount.service";
import { showApplicationLoader, hideApplicationLoader } from "common/ApplicationLoader";
import { GET_ACCOUNT_PAGE_LIST, getAdminAccountSearchListSuccess, openOverlayDialog, showError, } from '../common.action';
import { validateEmailAddressService } from "services/addUserService/validateEmailAddressAndMobileService";
import { DIALOG_TYPES } from "globals/global.constants";
import { getCurrentSenior } from "globals/global.functions";
import { resendOtpService } from "services/adminServices/agentAccount.service";
import { postCaregiverListService } from 'pages/WCPages/Admin/Assessment/CargiverAssessmentAdmin/caregiverAssessment.service';
import { showToast } from "common/Toast";
export var GET_CAREGIVER_LIST = 'GET_CAREGIVER_LIST';
export var GET_CAREGIVER_LIST_SUCCESS = 'GET_CAREGIVER_LIST_SUCCESS';
export var UPDATE_CARE_GIVER_LIST_PAGE_NUMBER = 'UPDATE_CARE_GIVER_LIST_PAGE_NUMBER';
export var GET_CARE_GIVER_SEARCH_LIST_SUCCESS = 'GET_CARE_GIVER_SEARCH_LIST_SUCCESS';
export var GET_CARE_GIVER_SEARCH_LIST = 'GET_CARE_GIVER_SEARCH_LIST';
export var SET_CG_TYPES = 'SET_CG_TYPES';
export var SET_CG_FILTER_TYPE = 'SET_CG_FILTER_TYPE';
export var SET_CG_FILTER_STATUS = 'SET_CG_FILTER_STATUS';
export var SET_CG_ACCOUNT_FILTER_STATUS = 'SET_CG_ACCOUNT_FILTER_STATUS';
export var GET_CARE_GIVER_LIST_SORT = 'GET_CARE_GIVER_LIST_SORT';
export var postCaregiverList = function (selectedCaregivers, showLoader, selectedAssessment) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var caregiverIds, params, res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (showLoader) {
                        dispatch(showApplicationLoader());
                    }
                    caregiverIds = selectedCaregivers.map(function (item) { return item.caregiver_id; });
                    params = {
                        caregiver_ids: caregiverIds,
                        version: 1,
                        assessment_type: selectedAssessment,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, postCaregiverListService(params)];
                case 2:
                    res = _a.sent();
                    if (res.applicationCode == 200) {
                        dispatch(showToast(res.message, 'success'));
                    }
                    return [2 /*return*/, res];
                case 3:
                    error_1 = _a.sent();
                    dispatch(showError(error_1));
                    return [3 /*break*/, 5];
                case 4:
                    if (showLoader) {
                        dispatch(hideApplicationLoader());
                    }
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var getCaregiverList = function (accountKey) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var cgAccount, _a, accountStatusValue, statusValue, cgValue, searchQuery, isActive, params, lastEvaluatedKey, response, error_2;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    dispatch(showApplicationLoader());
                    dispatch({ type: GET_ACCOUNT_PAGE_LIST, payload: accountKey });
                    cgAccount = getState().common.accounts[accountKey];
                    sessionStorage.setItem("".concat(accountKey, "Filters"), JSON.stringify(cgAccount === null || cgAccount === void 0 ? void 0 : cgAccount.queryParams));
                    _a = cgAccount === null || cgAccount === void 0 ? void 0 : cgAccount.queryParams, accountStatusValue = _a.accountStatusFilter, statusValue = _a.statusFilter, cgValue = _a.cgValue, searchQuery = _a.searchQuery;
                    isActive = null;
                    if (accountStatusValue === 'Enabled') {
                        isActive = 'true';
                    }
                    else if (accountStatusValue === 'Disabled') {
                        isActive = 'false';
                    }
                    params = {};
                    lastEvaluatedKey = cgAccount.lastEvaluatedKey;
                    if (lastEvaluatedKey) {
                        params.last_evaluated_key = lastEvaluatedKey;
                    }
                    if (searchQuery) {
                        params.search_by_name = searchQuery;
                    }
                    if (cgValue && cgValue !== 'All CG Types') {
                        params.caregiver_type = cgValue;
                    }
                    if (statusValue && statusValue !== 'All Status') {
                        params.account_status = statusValue.toLowerCase();
                    }
                    if (isActive) {
                        params.is_active = isActive;
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCaregiverService(params)];
                case 2:
                    response = _c.sent();
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, { data: ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.caregivers) || [] }];
                case 3:
                    error_2 = _c.sent();
                    dispatch(showError(error_2));
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getCaregiverSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data;
    dispatch({
        type: GET_CAREGIVER_LIST_SUCCESS,
        payload: {
            data: data,
        },
    });
}; };
export var updateCaregiverListPageNumber = function (value) { return function (dispatch) {
    dispatch({ type: UPDATE_CARE_GIVER_LIST_PAGE_NUMBER, payload: value });
}; };
export var isFirstLogin = function (email) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var param, response, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                param = {
                    email: email,
                };
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch(showApplicationLoader());
                return [4 /*yield*/, validateEmailAddressService(param)];
            case 2:
                response = _a.sent();
                dispatch(hideApplicationLoader());
                return [2 /*return*/, response.data];
            case 3:
                error_3 = _a.sent();
                console.error(error_3);
                dispatch(hideApplicationLoader());
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var enableDisableCaregiver = function (data, reason, currentUserName) {
    if (reason === void 0) { reason = null; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var isCurrentlyActive, params, response, actionText, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isCurrentlyActive = data === null || data === void 0 ? void 0 : data.is_active;
                    params = {
                        email: data.email,
                        is_active: !isCurrentlyActive,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    dispatch(showApplicationLoader());
                    return [4 /*yield*/, enableDisableCaregiverService(params)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getCaregiverList('cgAccount'))];
                case 3:
                    response = _a.sent();
                    dispatch(getAdminAccountSearchListSuccess(response || [], 'cgAccount'));
                    actionText = isCurrentlyActive ? 'disabled' : 'enabled';
                    dispatch(openOverlayDialog({
                        type: DIALOG_TYPES.SUCCESS,
                        firstMessage: "Caregiver ".concat(data.name.first_name, " ").concat(data.name.last_name, " ").concat(actionText, " successfully."),
                    }));
                    return [3 /*break*/, 6];
                case 4:
                    error_4 = _a.sent();
                    dispatch(showError(error_4));
                    return [2 /*return*/, error_4];
                case 5:
                    dispatch(hideApplicationLoader());
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var getCaregiverSearchListSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey;
    dispatch({
        type: GET_CARE_GIVER_SEARCH_LIST_SUCCESS,
        payload: {
            data: data,
            searchLastEvaluatedKey: lastEvaluatedKey,
        },
    });
}; };
export var getCaregiverListSort = function (tableData) { return function (dispatch) {
    dispatch({
        type: GET_CARE_GIVER_LIST_SORT,
        payload: {
            data: tableData,
        },
    });
}; };
export var resendOtpCare = function (email, showSuccessMessage, withAccountId, firstSeniorAccountId) {
    if (showSuccessMessage === void 0) { showSuccessMessage = true; }
    if (withAccountId === void 0) { withAccountId = false; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var params, accountID, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        email: email,
                    };
                    if (withAccountId) {
                        accountID = getCurrentSenior().accountID;
                        params.account = accountID;
                    }
                    if (firstSeniorAccountId) {
                        params.account = firstSeniorAccountId;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    dispatch(showApplicationLoader());
                    return [4 /*yield*/, resendOtpService(params)];
                case 2:
                    _a.sent();
                    dispatch(hideApplicationLoader());
                    if (showSuccessMessage) {
                        dispatch(openOverlayDialog({
                            type: DIALOG_TYPES.SUCCESS,
                            firstMessage: "OTP is successfully sent to email ".concat(email, "."),
                        }));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_5 = _a.sent();
                    dispatch(hideApplicationLoader());
                    dispatch(showError(error_5));
                    return [2 /*return*/, error_5];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
